import type { SVGProps } from "react";

export function IconDarkPurpleHandBanknote(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 34 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.375 4.125H26.625V13.75H7.375V4.125Z"
        stroke="#3E2247"
        strokeWidth="2.0625"
        strokeLinecap="square"
      />
      <path
        d="M19.75 8.9375C19.75 11.5954 18.5188 13.75 17 13.75C15.4812 13.75 14.25 11.5954 14.25 8.9375C14.25 6.27963 15.4812 4.125 17 4.125C18.5188 4.125 19.75 6.27963 19.75 8.9375Z"
        stroke="#3E2247"
        strokeWidth="2.0625"
        strokeLinecap="square"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8754 18.9062H9.77153C8.40401 18.9062 7.0925 19.4495 6.12551 20.4165L2.47949 24.0625L8.7504 30.3334L13.3026 25.7812H22.1668C23.5343 25.7812 24.8458 25.238 25.8128 24.271L31.1775 18.9063H28.2607L24.3544 22.8126C23.7742 23.3928 22.9873 23.7188 22.1668 23.7188H13.3026L10.5526 20.9687H19.4067V18.9063H12.8754V18.9062ZM8.11597 21.449L11.417 24.75L8.7504 27.4166L5.39631 24.0625L7.58392 21.8749C7.74634 21.7125 7.92495 21.57 8.11597 21.449Z"
        fill="#3E2247"
      />
    </svg>
  );
}
